import { createPortal } from "react-dom";

/**
 * Portal — Renders children into document.body via React.createPortal.
 *
 * Why this exists:
 *  Any ancestor with a `transform` (including animations like `.animate-apple-fade`
 *  which applies `transform: matrix(1,0,0,1,0,0)`) creates a new containing block
 *  for `position: fixed` descendants (per CSS spec). A modal using `fixed inset-0`
 *  will then be sized/positioned relative to that transformed ancestor instead of
 *  the viewport — causing offscreen headers, unreachable close buttons, and the
 *  "kapatamıyorum yazamıyorum sayfa yukarıda kaldı" trap bug.
 *
 * Usage:
 *   <Portal>
 *     <div className="fixed inset-0 z-50 ...">...</div>
 *   </Portal>
 */
export function Portal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}

export default Portal;
